import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-8f7fb048.js';
import { g as getControlInputAriaLabel } from './aria-f37957bf.js';

const marketRadioCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{--transition-duration:0.2s;--radio-offset:calc(-1 * var(--radio-border-size));position:relative;outline:none;position:relative;display:inline-block;width:var(--radio-width);height:var(--radio-height);border:var(--radio-border-size) solid var(--radio-normal-state-normal-validity-unselected-value-border-color);border-radius:var(--radio-border-radius);background-color:var(--radio-normal-state-normal-validity-unselected-value-background-color)}:host::after{--focus-ring-position:calc(-1 * (var(--radio-border-size) + var(--radio-focus-ring-buffer-size) + var(--radio-focus-ring-border-size, 2px)));content:'';position:absolute;top:var(--focus-ring-position);right:var(--focus-ring-position);bottom:var(--focus-ring-position);left:var(--focus-ring-position);display:block;border:var(--radio-focus-ring-border-size, 2px) solid var(--radio-focus-ring-color);border-radius:calc(var(--radio-border-radius) + var(--radio-focus-ring-buffer-size) * 2);opacity:0;pointer-events:none;transition:opacity 0.2s}:host(.focus-visible)::after{opacity:0.5}input{position:absolute;top:var(--radio-offset);left:var(--radio-offset);width:var(--radio-width);height:var(--radio-height);margin:0;outline:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}svg{position:absolute;top:calc(50% - var(--radio-svg-radius));left:calc(50% - var(--radio-svg-radius));align-items:center;pointer-events:none}:host(:hover),:host([hovered]){border-color:var(--radio-hover-state-normal-validity-unselected-value-border-color);background-color:var(--radio-hover-state-normal-validity-unselected-value-background-color)}:host([focused]){border-color:var(--radio-focus-state-normal-validity-unselected-value-border-color);background-color:var(--radio-focus-state-normal-validity-unselected-value-background-color)}:host(:active),:host([active]){border-color:var(--radio-pressed-state-normal-validity-unselected-value-border-color);background-color:var(--radio-pressed-state-normal-validity-unselected-value-background-color)}:host([invalid]){border-color:var(--radio-normal-state-invalid-validity-unselected-value-border-color);background-color:var(--radio-normal-state-invalid-validity-unselected-value-background-color)}:host([invalid]:hover),:host([invalid][hovered]){border-color:var(--radio-hover-state-invalid-validity-unselected-value-border-color);background-color:var(--radio-hover-state-invalid-validity-unselected-value-background-color)}:host([invalid][focused]){border-color:var(--radio-focus-state-invalid-validity-unselected-value-border-color);background-color:var(--radio-focus-state-invalid-validity-unselected-value-background-color)}:host([invalid]:active),:host([invalid][active]){border-color:var(--radio-pressed-state-invalid-validity-unselected-value-border-color);background-color:var(--radio-pressed-state-invalid-validity-unselected-value-background-color)}:host([selected]){border-color:var(--radio-normal-state-normal-validity-selected-value-border-color);background-color:var(--radio-normal-state-normal-validity-selected-value-background-color)}:host([selected]:hover),:host([selected][hovered]){border-color:var(--radio-hover-state-normal-validity-selected-value-border-color);background-color:var(--radio-hover-state-normal-validity-selected-value-background-color)}:host([selected][focused]){border-color:var(--radio-focus-state-normal-validity-selected-value-border-color);background-color:var(--radio-focus-state-normal-validity-selected-value-background-color)}:host([selected]:active),:host([selected][active]){border-color:var(--radio-pressed-state-normal-validity-selected-value-border-color);background-color:var(--radio-pressed-state-normal-validity-selected-value-background-color)}:host([invalid][selected]){border-color:var(--radio-normal-state-invalid-validity-selected-value-border-color);background-color:var(--radio-normal-state-invalid-validity-selected-value-background-color)}:host([invalid][selected]:hover),:host([invalid][selected][hovered]){border-color:var(--radio-hover-state-invalid-validity-selected-value-border-color);background-color:var(--radio-hover-state-invalid-validity-selected-value-background-color)}:host([invalid][selected][focused]){border-color:var(--radio-focus-state-invalid-validity-selected-value-border-color);background-color:var(--radio-focus-state-invalid-validity-selected-value-background-color)}:host([invalid][selected]:active),:host([invalid][selected][active]){border-color:var(--radio-pressed-state-invalid-validity-selected-value-border-color);background-color:var(--radio-pressed-state-invalid-validity-selected-value-background-color)}:host([disabled]){border-color:var(--radio-disabled-state-normal-validity-unselected-value-border-color) !important;background-color:var(--radio-disabled-state-normal-validity-unselected-value-background-color) !important}";

var ARIA_VALUE;
(function (ARIA_VALUE) {
  ARIA_VALUE["TRUE"] = "true";
  ARIA_VALUE["FALSE"] = "false";
})(ARIA_VALUE || (ARIA_VALUE = {}));
const MarketRadio = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.marketRadioValueChange = createEvent(this, "marketRadioValueChange", 7);
    this.selected = false;
    this.disabled = false;
    this.invalid = false;
    this.focused = false;
    this.hovered = false;
    this.active = false;
  }
  /**
   * Toggles `selected` prop, and emits a change event accordingly.
   * Used by `market-row` to sync its selected state w/ slotted radio buttons.
   */
  setSelection(newValue) {
    if (typeof newValue !== 'boolean') {
      return Promise.resolve();
    }
    const prevValue = this.selected;
    if (prevValue !== newValue) {
      this.selected = newValue;
      this.marketRadioValueChange.emit({
        current: newValue,
        previous: prevValue,
      });
    }
    return Promise.resolve();
  }
  /**
   * DEPRECATED (3.x): Toggles `selected` state (unrelated to the HTML attribute `value`).
   */
  setValue(newValue) {
    /* eslint-disable-next-line no-console */
    console.warn("market-radio's setValue() method has been deprecated. Use setSelection() instead.", this.el);
    this.setSelection(newValue);
    return Promise.resolve();
  }
  /**
   * Sets `active` state. Allows external elements to programmatically
   * trigger active styling, ex. when slotted as a control into `market-row`.
   */
  setActive(value) {
    this.active = value;
    return Promise.resolve();
  }
  /**
   * Sets `hovered` state. Allows external elements to programmatically
   * trigger hover styling, ex. when slotted as a control into `market-row`.
   */
  setHover(value) {
    this.hovered = value;
    return Promise.resolve();
  }
  /**
   * Sets `disabled` state. Allows external elements to programmatically
   * trigger disabled styling, ex. when slotted as a control into `market-row`.
   */
  setDisabled(value) {
    this.disabled = value;
    return Promise.resolve();
  }
  componentDidRender() {
    if (!this.innerInput) {
      this.innerInput = this.el.shadowRoot.querySelector('input');
    }
    if (this.selected) {
      this.innerInput.checked = this.selected;
    }
  }
  onFocus() {
    if (this.disabled) {
      return;
    }
    this.focused = true;
    this.el.shadowRoot.querySelector('input').focus();
  }
  onInputClick() {
    // once a radio is selected, it shouldn't be togglable/deselectable on click
    if (!this.selected) {
      this.setSelection(true);
    }
  }
  render() {
    const ariaChecked = this.selected ? ARIA_VALUE.TRUE : ARIA_VALUE.FALSE;
    return (h(Host, { class: "market-radio", role: "radio", "aria-checked": ariaChecked, onBlur: () => {
        this.focused = false;
      }, onClick: () => {
        this.onFocus();
      }, onFocus: () => {
        this.onFocus();
      } }, h("input", { type: "radio", "aria-checked": ariaChecked, "aria-label": getControlInputAriaLabel(this.el), checked: this.selected, disabled: this.disabled, onClick: () => {
        this.onInputClick();
      } }), this.selected && (h("svg", { width: "6", height: "6", viewBox: "0 0 6 6", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("circle", { cx: "3", cy: "3", r: "3", fill: "white" })))));
  }
  get el() { return getElement(this); }
};
MarketRadio.style = marketRadioCss;

export { MarketRadio as market_radio };
